import { Menu, Button, type ButtonProps, Tooltip } from '@mantine/core'

import { type ParameterID } from '@flecto/types'
import { Icon } from '@flecto/ui'

import {
  type BookingActionType,
  useBookingActions,
} from '../../../booking-actions'

export type DropdownActionProps = ButtonProps & {
  bookingId?: ParameterID
  actionKey: BookingActionType
  hideLabel?: boolean
}

export function DropdownAction({
  bookingId,
  actionKey,
  hideLabel,
  ...props
}: DropdownActionProps) {
  const { getAction, hasCustomer, noHasCustomerNotification } =
    useBookingActions({ bookingId })

  const action = getAction(actionKey)

  if (!action?.options) {
    return null
  }

  return (
    <Menu shadow='md' position='bottom-end'>
      <Menu.Target>
        <Tooltip label={action.label} position='top'>
          <Button
            {...props}
            styles={() => ({
              section: {
                marginRight: hideLabel ? 0 : undefined,
              },
            })}
            size='md'
            w={hideLabel ? '42px' : undefined}
            leftSection={<Icon icon={action.icon} />}
            color={props.color}
          >
            {!hideLabel && action.label}
          </Button>
        </Tooltip>
      </Menu.Target>

      <Menu.Dropdown miw='8.75rem'>
        {action.options.map((option) => (
          <Menu.Item
            key={option.value}
            onClick={() => {
              if (!hasCustomer) {
                noHasCustomerNotification()
              } else {
                action.action(option)
              }
            }}
          >
            {option.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
